module.exports = __webpack_public_path__ + "media/images/icons/country_flags/no-b9cc4fcdf51eb234607e1ffa96e3ff63.svg";